import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Benefits from './components/Benefits';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import SEO from '../../components/feature/SEO';

const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'SafeStay Solutions',
    description:
      'Specialized home accessibility and safety construction company serving Beverly, MA and the North Shore.',
    url: `${siteUrl}/`,
    telephone: '+16175396650',
    email: 'safestayma@gmail.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Beverly',
      addressLocality: 'Beverly',
      addressRegion: 'MA',
      postalCode: '01915',
      addressCountry: 'US',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '42.5584',
      longitude: '-70.8800',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '18:00',
      },
    ],
    priceRange: '$$',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '2500',
    },
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'SafeStay Solutions',
    url: `${siteUrl}/`,
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="SafeStay Solutions - Home Accessibility & Safety Construction in Beverly, MA"
        description="SafeStay Solutions provides professional home accessibility modifications in Beverly, MA. 25+ years experience helping seniors age in place safely with bathroom modifications, stair lifts, ramps, and doorway widening. Free home safety assessment. Licensed & insured."
        keywords="home accessibility Beverly MA, aging in place modifications, bathroom safety installation, wheelchair ramps, stair lifts Beverly, elderly home safety"
        canonical={`${siteUrl}/`}
        ogUrl={`${siteUrl}/`}
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Benefits />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
